import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

import {
  checkAnyScope,
  checkBooleanScope,
} from "@src/components/LimitAccess/check-scopes";

import {
  EXPERIENCE_ROUTES,
  EXPERIMENT_ROUTES,
  PERSONALIZATION_ROUTES,
} from "../../routes";

export const PersonalizationPaddedRoutes: RouteObject[] = [
  {
    path: PERSONALIZATION_ROUTES.Personalizations,
    lazy: async () => {
      const { ExperiencesRoute } = await import(
        "../../../features/personalizations/pages/personalizationOverview/Experiences.route"
      );
      const { ScopedRoute } = await import(
        "@src/components/LimitAccess/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("personalizations", org.configurations),
              ])
            }
            debugId={PERSONALIZATION_ROUTES.Personalizations}
            children={ExperiencesRoute}
          />
        ),
      };
    },
  },
];
